<template>
  <div style="position: relative;">
    <!-- 轮播图 -->
    <img class="top-nav" src="../assets/tops.png" alt="返回顶部" @click="topOne">
    <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
      <!-- 轮播图11 -->
      <swiper-slide class="swiper_slide_item">
        <swiper :options="swiperTop" ref="swiperTop" id="swiperTop">
          <div class="left-button" @click="slidePrev">
            <img src="../assets/butzuo.png" alt="">
          </div>
          <div class="right-button" @click="slideNext">
            <img src="../assets/butyou.png" alt="">
          </div>
          <swiper-slide>
            <div class="one-card" style="position: relative; width: 100%; height: 100vh;">
              <video @click="jumpWebs"
                src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/wxxiaodian/%E4%B8%8B%E8%BD%BD%20%281%29.mp4"
                autoplay muted loop
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"
                preload="auto">
              </video>
              <div class="text-overlay" style="width: 80%; height: 400px; display: flex; flex-direction: column;">
                <img src="../assets/thHy.png" style="width: 50%; margin-top:450px;">
                <div>
                  <button class="gradient-btn" @click="jumpWebs">点击进入</button>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/nav.png" style="width: 100%; height: 100vh;">
          </swiper-slide>
          <swiper-slide style="position: relative;">
            <img src="../assets/navq.png" style="width: 100%; height: 100vh;" @click="jumpZh">
            <div style="position: absolute;   bottom: 320px;  left: 20%; transform: translateX(-50%);">
              <button class="gradient-btn" style="min-width: 320px;" @click="jumpZh">点击智慧码门店申请</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/navw.png" style="width: 100%; height: 100vh;">
          </swiper-slide>
          <!--分页器-->
          <div class="top-pagination" slot="pagination"></div>
        </swiper>
      </swiper-slide>
      <!--必须的组件-->
      <!--每页幻灯片使用swiper-slide标签-->
      <!-- 1 -->
      <swiper-slide class="swiper_slide_item">
        <div class="one-card">
          <div class="card-Tit " :class="activeIndex == 1 ? 'animated-title' : ''">关于我们</div>
          <div class="card-two">
            <div class="card-left" :class="activeIndex == 1 ? 'animated-content' : ''"
              style="margin-top: 50px; font-size: 20px;">
              智慧谷集团是一家专注于构建产业数字化生态系统平台的国家高新技术企业、厦门市专精特新中小企业，集团致力于智慧区、智慧产业和智慧商圈的综合运营。我们以自主数字化应用技术为基础，积极探索数字经济新模式，引导产业链向数字化智能化方向转型，推动产业升级。
              <div>
                <div class="card-left" :class="activeIndex == 1 ? 'animated-content' : ''"
                  style="margin-top: 50px; font-size: 20px;">
                  智慧谷集团是国家级高新技术企业，以“构筑数字经济发展新范式”为使命，矢志成为“全球产业数字化生态建设的百年领军者”。我们以自主研发的智谷链WEC-Dapp-PaaS系统与AI工具链为双核引擎，打造开放协同的产业数字化生态平台，驱动实体经济全链路升级，引领中国数字经济标杆实践。智慧谷集团将持续深化“技术-平台-生态”三位一体战略，携手全球伙伴共筑数字文明新时代!
                </div>
                <!-- <div class="more-btn">
                  查看更多 <span class="arrow">→</span>
                </div> -->
              </div>
            </div>
            <div class="card-img" :class="activeIndex == 1 ? 'animated-image' : ''" style="margin-top: 30px;">
              <video controls style="width: 100%; height: 100%; object-fit: cover"
                controlslist="nodownload noremoteplayback noplaybackrate" disablepictureinpicture
                src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/card_video/WeChat_20240708095753.mp4"
                poster="../assets/popop.jpg">
              </video>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 第二块 -->
      <swiper-slide class="swiper_slide_item">
        <div class="two-card" style="padding-top: 50px;">
          <div class="card-Tit" :class="activeIndex == 2 ? 'animated-title-second' : ''">为什么选择智慧谷</div>
          <div class="card-subtitle " :class="activeIndex == 2 ? 'animated-title-second' : ''">国内首批网信办备案成功，国家高新技术企业
          </div>
          <div class="certificates-container">
            <!-- 1 -->
            <div class="certificates-row top-row" :class="activeIndex == 2 ? 'animated-cert-left' : ''">
              <div class="certificate-item ">
                <img src="../assets/b.png" alt="2023年获厦门市科学技术高新技术企业认证">
                <p>2023年获厦门市科学技术高新技术企业认证</p>
              </div>
              <div class="certificate-item">
                <img src="../assets/c.png" alt="国家网信办备案的数字营销App开发许可">
                <p>国家网信办备案的数字营销App开发许可</p>
              </div>
              <div class="certificate-item">
                <img src="../assets/a.png" alt="2023年获厦门市创新型中小企业">
                <p>2023年获厦门市创新型中小企业</p>
              </div>
            </div>
            <!-- 2 -->
            <div class="certificates-row bottom-row " :class="activeIndex == 2 ? 'animated-bottom-row' : ''">
              <div class="certificate-item">
                <img src="../assets/d.png" alt="2022年获厦门市科技服务协会理事单位">
                <p>2022年获厦门市科技服务协会-理事单位</p>
              </div>
              <div class="certificate-item">
                <img src="../assets/f.png" alt="2024年获厦门市科技局专精特新中小企业认证">
                <p>2024年获厦门市科技局专精特新中小企业认证</p>
              </div>
              <div class="certificate-item">
                <img src="../assets/e.png" alt="2022年获厦门市软件协会团体会员证书">
                <p>2022年获厦门市软件协会团体会员证书</p>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 第三 -->
      <swiper-slide class="swiper_slide_item">
        <div class="video-containers">
          <video ref="video2"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/8f698e6ef6a9bd77bde6dbd213578532.mp4" autoplay
            muted loop style="width: 100%; height: 100%; object-fit: cover;" preload="auto">
          </video>
          <div style="display: flex; flex-direction: column;align-items: center; justify-content: center; ">
            <div class="text-overlays" :class="activeIndex == 3 ? 'animated-news-item' : ''">智谷链领先技术</div>
            <p class="subtitle" :class="activeIndex == 3 ? 'animated-news-item' : ''">探索区块链底层技术的开发</p>
          </div>
        </div>
      </swiper-slide>
      <!-- 4 -->
      <!-- 4 核心业务 https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/0cc79bd44db6b0f878163b64edb07413.mp4-->
      <swiper-slide class="swiper_slide_item">
        <div class="core-business" style="padding-top: 50px;">
          <div class="card-Tit" :class="activeIndex == 4 ? 'animated-news-item' : ''">核心业务</div>
          <div class="business-tabs" :class="activeIndex == 4 ? 'animated-news-item' : ''">
            <div class="tab-nav">
              <div v-for="(tab, index) in businessList" :key="index"
                :class="['tab-item', { active: businessActive === index }]" @click="switchTab(index)"
                style="color: #989898;">
                {{ tab.name }}
              </div>
            </div>
            <!-- 椭圆 -->
            <div style="position: absolute; width: 100%; height: 80%; margin-top: 50px;" v-if='activeIndex == 4'>
              <div class="ellipse " :class="{
                'active top': businessActive === 0 || businessActive === 2 || businessActive === 4,
                'active tops ': businessActive === 1 || businessActive === 3 || businessActive === 5
              }">
              </div>
              <div class="ellipse " :class="{
                'active left': businessActive === 0 || businessActive === 2 || businessActive === 4,
                'active lefts': businessActive === 1 || businessActive === 3 || businessActive === 5
              }">
              </div>
              <div class="ellipse " :class="{
                'active bottom': businessActive === 0 || businessActive === 2 || businessActive === 4,
                'active bottoms': businessActive === 1 || businessActive === 3 || businessActive === 5
              }">
              </div>
            </div>
            <div class="tab-content">
              <div v-show="businessActive === 0" class="tab-pane">
                <div class="tab-pane-content">
                  <div class="tab-pane-content">
                    <div class="feature-list">
                      <div class="pane-tit">
                        <div class="paneCon">智慧谷超算公有链(简称：智谷链)</div>
                        <div style="color: #9EACBC;">Wisdom Valley Electronic supercomputing Public chain(简称:WEC)</div>
                      </div>
                      <div class="feature-item">
                        <div class="feature-header">
                          <img src="../assets/aq.png" alt="">
                          <h4>安全</h4>
                        </div>
                        <p>国际标准开发，符合国家监管方向</p>
                      </div>
                      <div class="feature-item">
                        <div class="feature-header">
                          <img src="../assets/yyscs.png" alt="">
                          <h4>应用市场广</h4>
                        </div>
                        <p>以区块链技术为核心，打造底层应用公链，联盟构建平台</p>
                      </div>
                      <div class="feature-item">
                        <div class="feature-header">
                          <img src="../assets/scgqh.png" alt="">
                          <h4>市场高契合</h4>
                        </div>
                        <p>结合实体产业需求，定制数字功能模块</p>
                      </div>
                      <div class="feature-item">
                        <div class="feature-header">
                          <img src="../assets/lsqfw.png" alt="">
                          <h4>链上全服务</h4>
                        </div>
                        <p>链上产业、技术、资源互通，打造良性生态圈</p>
                      </div>
                    </div>
                  </div>
                  <!-- 右侧 -->
                  <div class="right-image-content">
                    <img src="../assets/youcs.png">
                  </div>
                </div>
              </div>
              <!-- 加入椭圆变化 -->
              <div v-show="businessActive === 1" class="tab-pane">
                <div class="dappNum">
                  <img src="../assets/qltdapp.png" alt="" class="dapp-image">
                </div>
              </div>
              <div v-show="businessActive === 2" class="tab-pane">
                <div class="passNum">
                  <img src="../assets/thzyfw.png" alt="" class="dapp-image">
                </div>
              </div>
              <div v-show="businessActive === 3" class="tab-pane">
                <div class="chain-service-content">
                  <div class="service-grid">
                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/kfjk.png">
                        </div>
                        <h4>开放接口</h4>
                      </div>
                      <p>自有区块链底层系统成果共享，搭建智慧谷开放平台，同时结合云服务特色的按需付费、弹性伸缩和可视化的数据管理等特性，有效降低企业的开放接口初始成本和使用成本。</p>
                    </div>
                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/sjds.png">
                        </div>
                        <h4>社交电商</h4>
                      </div>
                      <p>围绕社交零售和分享经济，通过低门槛分销功能+多渠道口碑分享形成裂变式传播。商家能一手掌握用户数据和营销数据，且自带的社群功能可以让商家和消费者进行高效及时的互动大幅提高产品的转化率。</p>
                    </div>
                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/xxsl.png">
                        </div>
                        <h4>信息上链</h4>
                      </div>
                      <p>结合区块链共享账本的公开透明特性，将企业关键信息公开透明展示，帮助企业低成本、快速获得融资。</p>
                    </div>
                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/zcsl.png">
                        </div>
                        <h4>资产上链</h4>
                      </div>
                      <p>帮助企业将身份、客户、资产、供应链、交易等信息上链，增加品牌公信力，获得品牌溢价，实现产业升级转型。</p>
                    </div>
                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/sjgx.png">
                        </div>
                        <h4>数据共享</h4>
                      </div>
                      <p>各产业间通过区块链技术进行深度融合，用户粉丝群数据全打通，共享积分兑换和平台通证激励制度，留住老用户的同时轻松促活、拉新。</p>
                    </div>
                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/znhy.png">
                        </div>
                        <h4>智能合约</h4>
                      </div>
                      <p>帮助企业以低成本的方式精简业务流程，同时保证业务正常流转，如融资合约、开具发票、支付薪酬、偿还账单、上保险、处理库存清单等</p>
                    </div>

                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/kxzc.png">
                        </div>
                        <h4>可信众筹</h4>
                      </div>
                      <p>独创数字DTO模式结合区块链技术，让生产者、消费者、平台运营者三位一体，以销定产，促进跨境贸易，以物易物，实现订单经济，解决产能过剩问题、加快资产流通。</p>
                    </div>
                    <div class="service-item">
                      <div class="service-header">
                        <div class="service-icon">
                          <img src="../assets/oldsy.png">
                        </div>
                        <h4>OID溯源</h4>
                      </div>
                      <p>融合物联网、5G、大数据和区块链等技术，落地商品溯源和唯一性，实现物理世界和信息世界的互通融合</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 智慧谷ai芯片 -->
              <div v-show="businessActive === 4" class="tab-pane">
                <div class="ai-process">
                  <img src="../assets/thhxyw.png" class="ai-process-img">
                </div>
              </div>
              <div v-show="businessActive === 5" class="tab-pane">
                <div class="ai-assistant-content">
                  <h3>智谷AI可以做什么？</h3>
                  <p class="ai-description">
                    智谷AI是一套全面的智能AI系统，它可以成为您工作中的得力助手，协助您完成各种任务。智谷AI，作为一款领先的人工智能助手，致力于为用户提供高效、便捷、多样化的智能服务。它凭借四大核心功能--智能对话、智能创作、角色模拟和智能绘画，为用户带来前所未有的科技体验。
                  </p>
                  <div class="ai-features">
                    <div class="ai-feature-item">
                      <div class="feature-icon">
                        <img src="../assets/zndh.png" alt="智能对话">
                      </div>
                      <h4>智能对话</h4>
                    </div>
                    <div class="ai-feature-item">
                      <div class="feature-icon">
                        <img src="../assets/zncz.png" alt="智能创作">
                      </div>
                      <h4>智能创作</h4>
                    </div>
                    <div class="ai-feature-item">
                      <div class="feature-icon">
                        <img src="../assets/jsmn.png" alt="角色模拟">
                      </div>
                      <h4>角色模拟</h4>
                    </div>
                    <div class="ai-feature-item">
                      <div class="feature-icon">
                        <img src="../assets/znhh.png" alt="智能绘画">
                      </div>
                      <h4>智能绘画</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 新闻活动5 -->
      <!-- <swiper-slide class="swiper_slide_item">
        <div class="news-card">
          <div class="card-Tit " :class="activeIndex == 5 ? 'animated-title' : ''">新闻活动</div>
          <div class="news-container" :class="activeIndex == 5 ? 'animated-title' : ''">
            <div v-for="(a, index) in newsData.slice(0, 3)" :key="index" class="news-card-item">
              <div class="news-image">
                <img :src="a.pic" style="object-fit:contain" alt="news image">
              </div>
              <div class="news-content">
                <div class="news-date">{{ toTime(a.createtime) }}</div>
                <div class="news-title">{{ a.title }}</div>
                <img src="../assets/rights.png" alt="">
              </div>
            </div>
            <div class="news-sidebar">
              <div v-for="(a, index) in newsData.slice(3,7)" :key="'sidebar-' + index" class="news-list-item">
                <div class="news-date">{{ toTime(a.createtime) }}</div>
                <div class="news-title">{{ a.title }}</div>
              </div>
            </div>
          </div>
          <div class="content-wrapper">
            <div class="more-btn">
              查看更多 <span class="arrow">→</span>
            </div>
          </div>
        </div>
      </swiper-slide> -->
      <!-- 6696666666 -->
      <swiper-slide class="swiper_slide_item">
        <div class="video-container">
          <video ref="video1"
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/%E9%A2%84%E5%90%88%E6%88%90%205.mp4" autoplay muted
            loop style="width: 100%; height: 100%;object-fit: cover;" preload="auto">
          </video>
          <div class="text-overlay">应用场景</div>
        </div>
      </swiper-slide>
      <!-- 生态合作伙伴第7块 -->
      <swiper-slide class="swiper_slide_item">
        <div class="ecology" style="padding-top: 50px;">
          <div class="card-Tit" :class="activeIndex == 6 ? 'animated-title-second' : ''">生态合作伙伴</div>
          <div class="card-subtitle" :class="activeIndex == 6 ? 'animated-title-second' : ''">智慧谷与全产业链共同赋能企业转型之路</div>
          <div class="partner-container">
            <!-- 第一排 -->
            <div class="partner-row" :class="activeIndex == 6 ? 'animated-partner-row' : ''">
              <div class="partner-item"><img src="../assets/zgbq.png" alt="中国版权中心"></div>
              <div class="partner-item"><img src="../assets/zdkj.png" alt="中电科技"></div>
              <div class="partner-item"><img src="../assets/qhdx.png" alt="清华大学"></div>
              <div class="partner-item"><img src="../assets/zgyl.png" alt="中国智慧科学研究院"></div>
              <div class="partner-item"><img src="../assets/tj.png" alt="太极"></div>
            </div>
            <!-- 第二排 -->
            <div class="partner-row" :class="activeIndex == 6 ? 'animated-partner-row-delay1' : ''">
              <div class="partner-item"><img src="../assets/zw.png" alt="正威"></div>
              <div class="partner-item"><img src="../assets/xljs.png" alt="新浪长安服务"></div>
              <div class="partner-item"><img src="../assets/hzsl.png" alt="慧真数联"></div>
              <div class="partner-item"><img src="../assets/dfzh.png" alt="东方建设"></div>
              <div class="partner-item"><img src="../assets/gjt.png" alt="北京区块链技术应用协会"></div>
            </div>
            <!-- 第三排 -->
            <div class="partner-row" :class="activeIndex == 6 ? 'animated-partner-row-delay2' : ''">
              <div class="partner-item"><img src="../assets/zggl.png" alt="中国钢联"></div>
              <div class="partner-item"><img src="../assets/xsb.png" alt="新三板"></div>
              <div class="partner-item"><img src="../assets/pdd.png" alt="拼多多"></div>
              <div class="partner-item"><img src="../assets/rwaq.png" alt="国监通"></div>
              <div class="partner-item"><img src="../assets/bjqk.png" alt="东方智慧"></div>
            </div>
            <!-- 第四排 -->
            <div class="partner-row" :class="activeIndex == 6 ? 'animated-partner-row-delay1' : ''">
              <div class="partner-item"><img src="../assets/js.png" alt="中国钢联"></div>
              <div class="partner-item"><img src="../assets/tx.png" alt="新三板"></div>
              <div class="partner-item"><img src="../assets/mt.png" alt="拼多多"></div>
              <div class="partner-item"><img src="../assets/hw.png" alt="国监通"></div>
              <div class="partner-item"><img src="../assets/dy.png" alt="东方智慧"></div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- 8 -->
      <swiper-slide class="swiper_slide_item">
        <!-- 底部 -->
        <div class="card-imgs " :class="activeIndex == 7 ? 'animated-image' : ''">
          <video
            src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/wxxiaodian/jimeng-2025-07-02-6676-%E9%A2%97%E7%B2%92%E4%BB%8E%E8%BF%9C%E5%A4%84%E5%90%91%E8%BF%91%E5%A4%84%E6%89%91%E9%9D%A2%E8%80%8C%E6%9D%A5.mp4"
            autoplay muted loop style="width: 100%; height: 100%;  object-fit: cover;" preload="auto">
          </video>
          <div class="gradient-con">
            <div class="gradient-text ">链上生态互融 共享数字未来</div>
            <div class="gradient-p">智慧谷-您的企业数改服务商</div>
          </div>
        </div>
        <div class="footer" :class="activeIndex == 7 ? 'animated-image' : ''">
          <div class="footer_top">
            <!-- 左 -->
            <div class="footerTopLeft">
              <!-- 1 -->
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumps">走进智慧谷</h4>
                <p>企业简介</p>
                <p>发展历程</p>
                <p>企业荣誉</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4>核心业务</h4>
                <p>PAAS数字服务平台</p>
                <p>DAPP移动生态系统</p>
                <p>CHAIN企业链改服务</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4>应用场景</h4>
                <p>数字支付</p>
                <p>数字金融</p>
                <p>数字商城</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4>合作规划</h4>
                <p>未来规划</p>
                <p>合作目标</p>
                <p>全球布局</p>
              </div>
            </div>
            <!-- 右 -->
            <div class="footerTopRight">
              <!-- 1 -->
              <!-- <div class="RightCon" style="font-size: 20px;">
						<p style="cursor: pointer;">联系我们</p>
					</div> -->
              <div class="RightCon">
                <img src="../assets/tel.png" mode=""></img>
                <p>电话：400-8537-168</p>
              </div>
              <div class="RightCon">
                <img src="../assets/web.png" mode=""></img>
                <p style="cursor: pointer;">网址：www.gjzhg.com</p>
              </div>
              <div class="RightCon">
                <img src="../assets/email.png" mode=""></img>
                <p style="cursor: pointer;">邮箱：zhgjt@gjzhg.com</p>
              </div>
              <div class="RightCon">
                <img src="../assets/dz.png" mode=""></img>
                <p style="cursor: pointer;">地址：福建省厦门市集美区杏林湾营运中心总部大厦6号楼</p>
              </div>
              <!-- code -->
              <div class="code">
                <div style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                  <img src="../assets/gzh.jpg" alt="" style="width: 90px;height: 90px;border-radius: 10px;">
                  <h5 style="cursor: pointer;">扫一扫关注我们</h5>
                </div>
                <div style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                  <img src="../assets/kf.png" alt="" style="width: 90px;height: 90px;border-radius: 10px;">
                  <h5 style="cursor: pointer;">扫一扫添加客服</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="footer_botm">
            <p style="text-indent:1em;">版权所有：智慧谷(福建)数字科技集团有限公司</p>
            <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
            <p style="text-indent:1em;">闽ICP备16005520号-1</p>
            <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
            <p style="text-indent:1em;">本网站由阿里云提供云计算及安全服务 </p>
            <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
            <p style="text-indent:1em;"> 本网站支持 IPv6 </p>
            <p style="text-indent:1em;">|</p>
            <p style="text-indent:1em;"> Powered by CloudDream </p>
          </div>
        </div>
      </swiper-slide>
      <!-- 可选的控件 -->
      <!--分页器-->
      <div class="swiper-pagination" slot="pagination"></div>

    </swiper>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import axios from 'axios';
export default {
  name: "FullPage",
  data() {
    return {
      activeIndex: 0,
      newsData: [],
      pageIndex: 0,
      businessActive: 0,
      timeoutId: null,
      intervalId: null,
      businessList: [
        { name: '智慧谷超算公链' },
        { name: '企链通DAPP数字商城平台' },
        { name: 'PASS数据中台服务' },
        { name: 'CHAIN企业链改服务' },
        { name: '智慧谷AI芯片' },
        { name: '智慧谷全能助手' }
      ],
      swiperOption: {
        direction: "vertical",
        mousewheel: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          slideChange: () => {
            this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex;
            console.log(this.activeIndex, ' this.activeIndex');
          }
        }
      },
      swiperTop: {
        direction: "horizontal",
        mousewheel: true,
        autoplay: { delay: 15000, disableOnInteraction: false },
        pagination: {
          el: ".top-pagination",
          clickable: true
        },
        on: {
          slideChange: () => { }
        }
      }
    };
  },
  methods: {
    switchTab(index) {
      this.businessActive = index;
      this.pageIndex = index;
      // 清除定时器，重置 15 秒的计时
      clearTimeout(this.timeoutId);
      // 重启15秒监控
      this.resetTimeout();

      // 如果有正在进行的定时器，清除并重新启动自动切换定时器
      clearInterval(this.intervalId);
      this.autoSwitchTab();
    },

    // 自动切换 tab
    autoSwitchTab() {
      this.intervalId = setInterval(() => {
        // 自动切换到下一个 tab
        this.businessActive = (this.businessActive + 1) % this.businessList.length;
        this.pageIndex = this.businessActive;
      }, 10000); // 每 10 秒切换一次
    },

    // 监控 businessActive 的变化，如果15秒没有变化则触发 autoSwitchTab
    resetTimeout() {
      this.timeoutId = setTimeout(() => {
        this.autoSwitchTab(); // 如果15秒内没有变化，触发自动切换 tab
      }, 15000); // 15秒没有变化则触发
    },
    topOne() {
      this.$refs.mySwiper.$swiper.slideTo(0);
      this.activeIndex = 0
    },
    getNews() {
      axios.get('https://news-admin.gjwec.com/api/index/getNewsList', {
        params: {
          page: 1,
          pageSize: 7
        }
      })
        .then((res) => {
          console.log(res);
          if (res.data.data) {
            this.newsData = res.data.data.data;
          }
        })
        .catch((error) => {
          console.error('Error fetching news:', error);
        });
    },
    toTime(timestamp) {
      var date = new Date(timestamp * 1000);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      return Y + M + D;
    },
    jumps() {
      window.location.href = 'https://www.gjzhg.com/#/pages/step/step?num=0'
    },
    // 跳转智慧码
    jumpZh() {
      window.location.href = 'https://web-aggregation.gjwec.com'
    },
    jumpWebs() {
      window.location.href = 'https://open.gjwec.com/#/'
    },
    slidePrev() {
      this.$refs.swiperTop.$swiper.slidePrev();
    },
    slideNext() {
      this.$refs.swiperTop.$swiper.slideNext();
    }
  },
  // ... existing lifecycle hooks and other options

  mounted() {
    // 初始化定时器，开始监听
    this.autoSwitchTab();
    this.resetTimeout();
    this.getNews();
  },

  watch: {
    // 监听 businessActive 变量的变化
    businessActive(newVal, oldVal) {
      // 每次 businessActive 变化时，重置15秒的计时器
      clearTimeout(this.timeoutId);
      this.resetTimeout();

    },
    // 视频切换一直播放
    activeIndex(newVal, oldVal) {
      // console.log(newVal, oldVal,'ppppppp');
      if (newVal == 5) {
        let video = this.$refs.video1;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }
      if (newVal == 3) {
        let video = this.$refs.video2;  // 获取视频元素
        if (video) {
          video.currentTime = 0;  // 将视频播放时间重置为 0
          video.play();  // 播放视频
        }
      }
      // 核心业务
      if (newVal == 4) {
        this.businessActive = 0
      }
    },
  },
  methods: {
    switchTab(index) {
      this.businessActive = index;
      this.pageIndex = index;
      // 清除定时器，重置 15 秒的计时
      clearTimeout(this.timeoutId);
      // 重启15秒监控
      this.resetTimeout();

      // 如果有正在进行的定时器，清除并重新启动自动切换定时器
      clearInterval(this.intervalId);
      this.autoSwitchTab();
    },

    // 自动切换 tab
    autoSwitchTab() {
      this.intervalId = setInterval(() => {
        // 自动切换到下一个 tab
        this.businessActive = (this.businessActive + 1) % this.businessList.length;
        this.pageIndex = this.businessActive;
      }, 10000); // 每 10 秒切换一次
    },

    // 监控 businessActive 的变化，如果15秒没有变化则触发 autoSwitchTab
    resetTimeout() {
      this.timeoutId = setTimeout(() => {
        this.autoSwitchTab(); // 如果15秒内没有变化，触发自动切换 tab
      }, 15000); // 15秒没有变化则触发
    },
    topOne() {
      this.$refs.mySwiper.$swiper.slideTo(0);
      this.activeIndex = 0
    },
    getNews() {
      axios.get('https://news-admin.gjwec.com/api/index/getNewsList', {
        params: {
          page: 1,
          pageSize: 7
        }
      })
        .then((res) => {
          console.log(res);
          if (res.data.data) {
            this.newsData = res.data.data.data;
          }
        })
        .catch((error) => {
          console.error('Error fetching news:', error);
        });
    },
    toTime(timestamp) {
      var date = new Date(timestamp * 1000);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      return Y + M + D;
    },
    jumps() {
      window.location.href = 'https://www.gjzhg.com/#/pages/step/step?num=0'
    },
    // 跳转智慧码
    jumpZh() {
      window.location.href = 'https://web-aggregation.gjwec.com'
    },
    jumpWebs() {
      window.location.href = 'https://open.gjwec.com/#/'
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.top-nav {
  width: 40px;
  height: 40px;
  position: fixed;
  right: 0em;
  top: 370px;
  z-index: 1000;
  cursor: pointer;
  transition: all 0.3s ease;
}

.top-nav:hover {
  transform: scale(1.1);
}

#mySwiper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.swiper-pagination {
  right: 2em;
}

/* 四个轮播 */
/* 配置分页器的颜色 */
#swiperTop {
  --swiper-pagination-color: #ffffff;
  /* 未选中状态颜色为白色 */
  --swiper-pagination-current-color: #0000ff;
  /* 选中状态颜色为蓝色 */
}

/* 如果想要分页器小圆点的大小和样式进行微调 */
.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.swiper-pagination-bullet-active {
  background-color: #0000ff;
  /* 选中的小圆点颜色为蓝色 */
}

.top-pagination {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.top-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  margin: 0 5px;
  background: #fff;
  opacity: 1;
  transition: all 0.3s ease;
}

.top-pagination .swiper-pagination-bullet-active {
  background: #fff;
  opacity: 0.5;
}

/* 智慧谷集团 */
.one-card {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  padding-top: 50px;

}

.gradient-btn {
  width: 280px;
  margin-top: 50px;
  height: 60px;
  padding: 10px 30px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(90deg, #2821FE 0%, #00D4FF 100%);
  color: white;
  font-size: 28px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.gradient-btn:hover {
  transform: scale(1.05);
}

/* 标题动画 - 从左侧滑入居中 */
.card-Tit {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  font-size: 33px;
  font-weight: bold;
  color: #333;
}

.animated-title {
  animation: slideInFromLeft 2s ease-out forwards;
  transform: translateX(-100%);
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 两块 */
.card-two {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 50px;
  margin-top: 50px;
  position: relative;
}

.card-left {
  flex: 1;
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  display: flex;
  flex-direction: column;
  text-indent: 2em;
}

.card-left .more-btn {
  text-indent: 0;
}

.card-img {
  flex: 1;
  height: 500px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}


.card-img video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.more-btn {
  margin-top: 30px;
  padding: 10px 30px;
  font-size: 16px;
  color: #304EFC;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  position: relative;
  /* border: 1px solid #304EFC; */
  border-radius: 5px;
  width: 100px;
}

/* .arrow {
  transition: transform 0.3s ease;
} */

/* .more-btn:hover .arrow {
  transform: translateX(5px);
} */

.animated-content {
  animation: slideInFromLeftContent 2s ease-out 0.5s forwards;
  transform: translateX(-100%);
  opacity: 0;
}

@keyframes slideInFromLeftContent {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 图片动画 - 从右往左居中 */
/* .card-img {
  flex: 1;
  max-width: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 120px;
} */

.card-img .vjs-custom-skin {
  width: 100%;
  max-width: 580px;
  height: 500px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid red;
}

.card-img .vjs-custom-skin video {
  object-fit: cover;
}

.animated-image {
  animation: slideInFromRight 1s ease-out forwards;
  transform: translateX(100%);
  opacity: 0;
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 第三页新闻活动样式 */
.news-card {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  padding-top: 100px;
}

.news-container {
  display: flex;
  gap: 30px;
  margin-top: 60px;
  padding: 0 2%;
  justify-content: center;
  align-items: flex-start;
}

.news-card-item {
  flex: 1;
  width: 320px;
  min-height: 380px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: 1px solid #f0f1f3;
}

/* 第三个 */
.news-sidebar {
  flex: 1;
  width: 320px;
  min-height: 380px;
  background: #f5f6fa;
  border-radius: 8px;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 0;
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 0;
}

.news-item.large-news {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: 1px solid #f0f1f3;
}

.news-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: start;
}

.news-image img {
  width: 100%;
  object-fit: fill;
  transition: transform 0.3s ease;
}

.news-content {
  padding: 18px 20px 20px;
  flex: 1;
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 0;
  position: relative;
}

.news-list-item {
  /* padding: 28px 0; */
  padding-bottom: 20px;
  border-bottom: 1px solid #e8eaed;
  cursor: pointer;

}

.news-list-item:last-child {
  border-bottom: none;
}

.news-date {
  color: #2155FE;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 8px;
  letter-spacing: 0.3px;
  padding-top: 20px;
}

.news-title {
  color: #333333;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
}

/* 动画效果查看更多 */
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;
}

.more-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  color: #0066FF;
  font-size: 16px;
  cursor: pointer;
  padding: 8px 16px;
  margin-top: 30px;
  overflow: hidden;
}

.more-btn::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 160px;
  /* 减小宽度 */
  height: 160px;
  /* 减小高度 */
  background: linear-gradient(90deg, #0066FF, #2196F3 20%);
  z-index: -2;
  animation: rotate1 1.3s linear infinite;
  transform-origin: 0 0;
}

.more-btn::after {
  content: '';
  position: absolute;
  left: 2px;
  /* 减小间距 */
  top: 2px;
  /* 减小间距 */
  width: calc(100% - 4px);
  /* 调整宽度 */
  height: calc(100% - 4px);
  /* 调整高度 */
  background: #fff;
  z-index: -1;
}

.more-btn .arrow {
  margin-left: 4px;
  animation: arrow-move 5s infinite;
}

@keyframes rotate1 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes arrow-move {

  0%,
  100% {
    transform: translateX(0);
  }

  50% {
    transform: translateX(4px);
  }
}

.news-item.large-news .news-date {
  color: #6c7293;
  font-size: 13px;
  font-weight: 400;
}

.news-item.large-news .news-title {
  color: #2c3e50;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
}

.news-list-item .news-title {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.4;
}



.news-content img {
  position: absolute;
  left: 20px;
  bottom: 50px;
  width: 30px;
  height: 10px;
}

/* 新闻动画效果 - 从左往右 */
.animated-news-item {
  animation: slideInFromLeftNews 1.5s ease-out forwards;
  transform: translateX(-100%);
  opacity: 0;
}

@keyframes slideInFromLeftNews {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 响应式设计 - 100%兼容 */
@media (max-width: 768px) {
  .card-two {
    flex-direction: column;
    gap: 30px;
  }

  .card-left,
  .card-img {
    max-width: 100%;
    width: 100%;
  }

  .card-Tit {
    font-size: 28px;
    margin-top: 40px;
  }

  .card-img img {
    height: 250px;

  }

  .one-card,
  .news-card {
    padding: 0 3%;
  }

  /* 新闻页面移动端样式 */
  .news-container {
    flex-direction: column;
    gap: 20px;
    margin-top: 40px;
    height: auto;
    align-items: center;
  }

  .news-card-item {
    width: 100%;
    max-width: none;
  }

  .news-sidebar {
    width: 100%;
    max-width: none;
    padding: 15px;
  }

  /* .news-image {
    height: 180px;
  } */

  .news-title {
    font-size: 14px;
  }

  .news-content {
    padding: 15px;
  }

  .news-list-item {
    padding: 12px 0;
  }

  .news-list-item:hover {
    padding: 12px 8px;
  }
}

@media (max-width: 480px) {
  .card-Tit {
    font-size: 24px;
    margin-top: 20px;
  }

  .card-left {
    font-size: 14px;
  }

  .card-img img {
    height: 200px;
  }

  .one-card,
  .news-card {
    padding: 0 2%;
  }
}

/* 第二页样式 */
.two-card {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.animated-title-second {
  animation: slideInFromLeft 1.5s ease-out forwards;
  transform: translateX(-100%);
  opacity: 0;
}

.card-subtitle {
  font-size: 18px;
  color: #888;
  margin-top: 20px;
  margin-bottom: 60px;
  text-align: center;
}

.animated-subtitle {
  animation: slideInFromLeft 1.5s ease-out 0.5s forwards;
  transform: translateX(-100%);
  opacity: 0;
}

.certificates-container {
  width: 100%;
  max-width: 1200px;
}

.certificates-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  gap: 30px;
  animation: slideInFromLeft 1.5s ease-out forwards;
  transform: translateX(-100%);
}

.certificate-item {
  flex: 1;
  max-width: 300px;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  transition-duration: 0.3s;
}

/* .certificate-item:hover {
  transform: translateY(-5px);
} */

.certificate-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 15px;
}

.certificate-item p {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  margin: 0;
}

/* 上排证书从左向右动画 - 居中对齐 */
.animated-cert-left {
  animation: slideInFromLeftCert 1.5s ease-out forwards;
  transform: translateX(-100%);
  opacity: 0;
}

@keyframes slideInFromLeftCert {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 下排证书整体从右向左动画 */
.animated-bottom-row {
  animation: slideInFromRightRow 2.5s ease-out forwards;
  transform: translateX(100%);
  opacity: 0;
}

@keyframes slideInFromRightRow {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* 第二页响应式设计 */
@media (max-width: 768px) {
  .certificates-row {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .certificate-item {
    max-width: 100%;
    width: 90%;
  }

  .card-subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .two-card {
    padding: 0 3%;
  }

  .certificate-item {
    padding: 15px;
  }

  .certificate-item img {
    height: 150px;
  }

  .certificate-item p {
    font-size: 12px;
  }
}

/* 生态合作伙伴样式 */
.ecology {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.partner-container {
  width: 100%;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
}

.partner-row {
  display: flex;
  justify-content: space-between;
  opacity: 0;
  gap: 60px;
}

.partner-item {
  flex: 1;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  transition: transform 0.6s ease;
}

/* .partner-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
} */

.partner-item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 合作伙伴动画 */
.animated-partner-row {
  animation: slideInFromLeft 2s ease-out forwards;
}

.animated-partner-row-delay1 {
  animation: slideInFromRight 2s ease-out forwards;
}

.animated-partner-row-delay2 {
  animation: slideInFromLeft 2s ease-out forwards;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .partner-container {
    margin-top: 40px;
    gap: 20px;
  }

  .partner-row {
    flex-wrap: wrap;
    gap: 15px;
  }

  .partner-item {
    flex: 0 0 calc(33.33% - 10px);
    height: 60px;
  }
}

@media (max-width: 480px) {
  .partner-item {
    flex: 0 0 calc(50% - 8px);
    height: 50px;
    padding: 10px;
  }
}


/* 核心业务 */
/* 核心业务样式 */
.core-business {
  width: 100%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(../assets/hxback.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.business-tabs {
  width: 100%;
  max-width: 1200px;
  margin-top: 40px;
}

.tab-nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 0.5);
  padding: 15px;
  border-radius: 50px;
}

.tab-item {
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 16px;
  color: #333;
}

.tab-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.tab-item.active {
  background: linear-gradient(90deg, #BFE9FF 0%, #D6E2FF 100%);
  color: #2c3e50;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
  border-radius: 50px;
}

.tab-content {
  padding: 40px;
}

.tab-pane {
  text-align: center;
}

.tab-pane h3 {
  font-size: 24px;
  color: #2c3e50;
  margin-bottom: 20px;
}

.tab-pane p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .tab-nav {
    flex-wrap: wrap;
    gap: 10px;
  }

  .tab-item {
    font-size: 14px;
    padding: 8px 15px;
  }

  .tab-content {
    padding: 20px;
  }

  .tab-pane h3 {
    font-size: 20px;
  }

  .tab-pane p {
    font-size: 14px;
  }
}

/* 超算公链 */
.tab-pane-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  border-radius: 20px;
  /* margin-top: 20px; */
}

.paneCon {
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 15px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* margin-top: 30px; */
}

.feature-item {
  background: rgba(255, 255, 255, 0.1);
  padding: 15px;
  border-radius: 8px;
}

.feature-header {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
}

.feature-item img {
  width: 32px;
  height: 32px;
}

.feature-item h4 {
  color: #000;
  font-size: 18px;
  margin: 0;
}

.feature-item p {
  color: #9EACBC;
  font-size: 14px;
  margin: 0;
  line-height: 2;
  margin-left: 5px;
}

.feature-item p {
  display: flex;
}

/* 右侧图片 */
.right-image-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  margin-left: 40px;
  /* border: 1px solid; */
  /* height: 400px; */
}

.right-image-content img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* dapp数字商城 */
.dappNum {
  /* position: relative; */
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ellipse {
  position: absolute;
  width: 300px;
  height: 150px;
  border-radius: 150px / 150px;
  background: rgba(64, 169, 255, 0.1);
  transition: all 0.5s ease;
  opacity: 0;
  transform: scale(0.8);
}

.ellipse.active {
  opacity: 1;
  transform: scale(1);
}

.ellipse.top {
  top: -30px;
  right: -50px;
  transform: translateX(50px);
}

.ellipse.left {
  left: -50px;
  top: 50%;
  transform: translateY(-50%);
}

.ellipse.bottom {
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
}

/* 135 */
.ellipse.tops {
  right: -50px;
  top: 50%;
  transform: translateY(-50%);
}

.ellipse.lefts {
  top: -30px;
  left: -50px;
  transform: translateX(50px);
}

.ellipse.bottoms {
  bottom: -30px;
  left: -30px;
  transform: translateX(-30px);
}

.ellipse.top-alt {
  top: 10px;
  left: 20%;
  transform: translateX(-50%);
}

.ellipse.left-alt {
  left: 20px;
  top: 40%;
  transform: translateY(-50%);
}

.ellipse.bottom-alt {
  bottom: 10px;
  left: 80%;
  transform: translateX(-50%);
}


.dapp-image {
  /* position: relative; */
  z-index: 1;
  max-width: 100%;
  height: auto;
}



/* pass数据中台服务 */
.passNum {
  /* background-image: url('../assets/ycpp.png'); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 80% center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dapp-image {
  max-width: 95%;
  height: auto;
  display: block;
  margin: 0 auto;
}

@media (max-width:880px) {
  .dapp-image {
    max-width: 100%;
  }
}

/* 企业链改服务 */
.chain-service-content {
  /* background-image: url('../assets/ycpp.png');
  background-repeat: no-repeat;
  background-size: 100% 100%; */
}

.service-grid {
  /* background-image: url('../assets/hexinyw.png'); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  /* border: 1px solid; */
}

/* 标题内容 */
.service-item {
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.service-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.service-icon {
  width: 35px;
  height: 35px;
  margin-right: 10px;
}

.service-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.service-item h4 {
  font-size: 16px;
  color: #333;
  margin: 0;
}

.service-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  text-align: justify;
  text-align-last: left;
  word-break: break-all;
  white-space: normal;
  width: fit-content;
}

@media screen and (max-width: 768px) {
  .service-grid {
    grid-template-columns: 1fr;
  }

  .service-item {
    padding: 15px;
  }
}

/* 智慧谷ai芯片 */
.ai-process {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 80% center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ai-process-img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

@media (max-width:880px) {
  .ai-process-img {
    max-width: 100%;
  }
}

/* 智慧谷全能助手 */
.ai-assistant-content {
  text-align: center;
}

.ai-assistant-content h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
}

.ai-description {
  font-size: 16px;
  color: #666;
  line-height: 2;
  margin: 0 auto 40px;
  max-width: 1300px;
  text-align: justify;

}

.ai-features {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 40px;
}

.ai-feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.feature-icon img {
  width: 200px;
  height: 200px;
}

.ai-feature-item h4 {
  font-size: 16px;
  color: #333;
  margin: 0;
}

@media (max-width: 768px) {
  .ai-features {
    flex-wrap: wrap;
    gap: 20px;
  }

  .ai-feature-item {
    width: calc(50% - 10px);
  }

  .feature-icon {
    width: 60px;
    height: 60px;
  }

  .feature-icon img {
    width: 30px;
    height: 30px;
  }
}

/* 底部导航栏 */
.footer {
  width: 100%;
  height: 340px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  color: #000;
  position: absolute;
  bottom: 0;
}

.footer_top {
  width: 100%;
  height: 300px;
  border-bottom: 1px solid #fff;
  display: flex;
  justify-content: center;
  padding-top: 30px;

}

.footerTopLeft {
  width: 50%;
  height: 210px;
  display: flex;
  justify-content: space-around;
  /* border: 1px solid; */
  margin-top: 20px;
}

.LeftCon p {
  font-size: 27rpx;
  text-align: center;
  color: #989898;
  cursor: pointer;
  line-height: 2.5;
}

.LeftCon h4 {
  color: #000;
  text-align: center;
  cursor: pointer;
  font-size: 18px;
}

.RightCon p {
  color: #989898;
  cursor: pointer;
}

/* 右边四个 */
.footerTopRight {
  height: 240px;
  font-size: 14px;
  position: relative;
  left: 3%;
  width: 40%;
}

.RightCon {
  height: 18%;
  display: flex;
  align-items: center;
}

.RightCon img {
  width: 25px;
  height: 25px;
  margin-right: 15px;
}

.RightCon p {
  color: #000;
  margin: 0;
  line-height: 25px;
}



.footerMidd {
  width: 70%;
  height: 75%;
  border-bottom: 1px solid #cacaca;
}

.code {
  position: absolute;
  right: 18%;
  top: 0;
  width: 35%;
  align-items: center;
  justify-content: space-around;
  display: flex;
}

.codes {
  width: 23%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.codes img {
  width: 100%;
  height: 100%;
}

.code h5 {
  margin-top: 10px;
}

.footer_botm {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  font-size: 16px;

}


/* 图片动画 - 从右往左居中 */
.card-imgs {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0;
  object-fit: fill;
  position: relative;
}

.vjs-custom-skin {
  width: 100%;
  height: 100%;
}

.video-js {
  width: 100% !important;
  height: 100% !important;
  min-height: 300px;
}

.video-js video {
  object-fit: cover;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
  .card-imgs {
    max-width: 100%;
    margin-right: 0;
  }

  .card-imgs .video-js {
    min-height: 250px;
  }
}

.gradient-con {
  position: absolute;
  margin-top: -380px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.gradient-text {
  font-size: 70px;
  /* 设置字体大小 */
  font-weight: bold;
  /* 可选的加粗 */
  background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
  -webkit-background-clip: text;
  /* Safari和Chrome支持 */
  background-clip: text;
  /* 适用于Firefox */
  color: transparent;
  /* 使文字透明，从而显示背景渐变 */
  padding-bottom: 30px;
}

.gradient-p {
  font-size: 40px;
  /* 设置字体大小 */
  font-weight: bold;
  color: #fff;
}


/* 新闻活动应用场景 */
.swiper_slide_item {
  position: relative;
  height: 100%;
}

.video-container {
  position: relative;
  height: 100%;
  overflow: hidden;

}

.text-overlay {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
  padding-top: 100px;
}



/* 智谷链 */
.video-containers {
  position: relative;
  height: 100%;
  overflow: hidden;
  padding-top: 10px;
}

.text-overlays {
  position: absolute;
  top: 100px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #333;
  font-size: 28px;
  font-weight: bold;
}

.subtitle {
  position: absolute;
  top: 150px;
  /* left: 50%; */
  transform: translateX(-50%);
  color: #A7A9AC;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/FullPage.vue